import { footerLinks, edition } from "@/mocks/gossip";

export default function Footer() {
  return (
    <footer className="bg-background-200 text-foreground-800">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
          {/* brand col */}
          <div className="col-span-2">
            <a href="#lead" className="inline-flex items-center gap-2.5" aria-label="返回顶部">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                <i className="ri-ink-bottle-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">最近黑料</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              以近期人物与新涉事者为中心，提供可回溯的背景梳理与事件还原阅读。
            </p>
            <p className="mt-3 text-xs text-foreground-500">当前版本 · {edition.issue} · {edition.date}</p>
            <div className="mt-5 flex gap-2">
              {["ri-instagram-line", "ri-weibo-line", "ri-rss-line"].map((i) => (
                <a key={i} href="#download" aria-label="社交入口" className="flex h-9 w-9 items-center justify-center rounded-md border border-foreground-950/15 text-foreground-700 hover:border-primary-500 hover:text-primary-700">
                  <i className={`${i} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {footerLinks.map((col) => (
            <div key={col.head}>
              <h4 className="mb-3 font-heading text-sm font-bold text-foreground-950">{col.head}</h4>
              <ul className="space-y-2">
                {col.items.map((item) => (
                  <li key={item}>
                    <a href="#download" className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-foreground-600 hover:text-primary-700">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-foreground-950/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="max-w-2xl text-xs leading-relaxed text-foreground-500">
            本站内容仅用于界面演示与阅读流程体验，所涉人物与事件均为虚构范例，不代表任何真实个人或机构；事实以当事方正式披露为准。
          </p>
          <a
            href="#lead"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-950/15 px-3.5 py-2 text-sm text-foreground-700 hover:border-primary-500 hover:text-primary-700"
          >
            <i className="ri-arrow-up-line" /> 回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}